import { Button, IconButton, Box, Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import WebOutlinedIcon from "@mui/icons-material/WebOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddCollection from "../../Modals/addcollection";

const ManageCollections = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState<number[]>([]);

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const toggleSelectItem = (id: number) => {
        setSelectedItems((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const collections = [
        {
            id: 1,
            name: "Summer Collection 2025",
            description: "Hot products for summer season",
            products: 24,
            featured: true,
            type: "Seasonal",
            reason: "Campaign • May - Aug",
            status: "Active",
            metadata: { startDate: "2025-05-01", endDate: "2025-08-31", timezone: "GST" },
            surfaces: ["Homepage", "App"],
            performance: { views: "12.5K", revenue: "AED 45K", ctr: "4.2%" }
        },
        {
            id: 2,
            name: "New Arrivals",
            description: "Latest products just added",
            products: 15,
            featured: true,
            type: "Dynamic",
            reason: "Rule-based • Updates daily",
            status: "Active",
            metadata: { startDate: "2024-01-01", endDate: "Continuous", timezone: "GST" },
            surfaces: ["Homepage", "Category page", "Search boost"],
            performance: { views: "8.2K", revenue: "AED 12K", ctr: "5.8%" }
        },
        {
            id: 3,
            name: "Best Sellers",
            description: "Top performing products",
            products: 0,
            featured: false,
            type: "Manual",
            reason: "Manual • No products added",
            status: "Draft",
            metadata: { startDate: "TBD", endDate: "TBD", timezone: "GST" },
            surfaces: ["Search boost"],
            performance: { views: "0", revenue: "AED 0", ctr: "0%" }
        },
        {
            id: 4,
            name: "Tech Essentials",
            description: "Must-have technology items",
            products: 42,
            featured: false,
            type: "Manual",
            reason: "Manual • Curated List",
            status: "Scheduled",
            metadata: { startDate: "2025-03-15", endDate: "2025-06-15", timezone: "GST" },
            surfaces: ["Category page", "Web only"],
            performance: { views: "2.1K", revenue: "AED 8K", ctr: "3.1%" }
        },
        {
            id: 5,
            name: "Home Office Setup",
            description: "Work from home essentials",
            products: 12,
            featured: false,
            type: "Seasonal",
            reason: "Seasonal • Winter",
            status: "Expired",
            metadata: { startDate: "2024-11-01", endDate: "2025-01-31", timezone: "GST" },
            surfaces: ["App only"],
            performance: { views: "5.5K", revenue: "AED 21K", ctr: "2.9%" }
        },
    ];

    const filtered = collections.filter((c) =>
        c.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div className="main_title">
                <h1>Manage Collections</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Manage Collections
                </p>
            </div>

            <div className="table_flex mt_20">
                <div className="lt">
                    {selectedItems.length > 0 && (
                        <div className="bulk_action_bar" style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '10px 16px',
                            background: '#fff',
                            borderRadius: '8px',
                            marginBottom: '16px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                            border: '1px solid #e5e7eb'
                        }}>
                            <Button
                                variant="contained"
                                sx={{
                                    background: '#c49133',
                                    '&:hover': { background: '#b0812b' },
                                    textTransform: 'none',
                                    borderRadius: '6px',
                                    height: '36px',
                                    fontSize: '14px',
                                    fontWeight: 600
                                }}
                                endIcon={<KeyboardArrowDownIcon />}
                            >
                                {selectedItems.length} Selected
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{
                                    color: '#4b5563',
                                    borderColor: '#d1d5db',
                                    textTransform: 'none',
                                    borderRadius: '6px',
                                    height: '36px',
                                    fontSize: '14px',
                                    '&:hover': { borderColor: '#9ca3af', background: '#f9fafb' }
                                }}
                            >
                                Activate / Deactivate
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{
                                    color: '#4b5563',
                                    borderColor: '#d1d5db',
                                    textTransform: 'none',
                                    borderRadius: '6px',
                                    height: '36px',
                                    fontSize: '14px',
                                    '&:hover': { borderColor: '#9ca3af', background: '#f9fafb' }
                                }}
                            >
                                Assign surface
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{
                                    color: '#4b5563',
                                    borderColor: '#d1d5db',
                                    textTransform: 'none',
                                    borderRadius: '6px',
                                    height: '36px',
                                    fontSize: '14px',
                                    '&:hover': { borderColor: '#9ca3af', background: '#f9fafb' }
                                }}
                            >
                                Archive
                            </Button>
                            <Box
                                component="a"
                                onClick={() => setSelectedItems([])}
                                sx={{
                                    cursor: "pointer",
                                    color: "#3b82f6",
                                    ml: 'auto',
                                    fontSize: "14px",
                                    textDecoration: 'none',
                                    '&:hover': { textDecoration: 'underline' }
                                }}
                            >
                                Cancel
                            </Box>
                        </div>
                    )}
                    <div className="cards">
                        <div className="table_header">
                            <div className="left_s">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search collections..."
                                />
                            </div>
                            <div className="right_s">
                                <Button className="btn btn_primary" onClick={() => setOpenModal(true)}>
                                    <AddIcon /> Add Collection
                                </Button>
                            </div>
                        </div>

                        {/* Modern Card Grid */}
                        <div className="modern_collection_grid">
                            {filtered.map((item) => (
                                <div className={`modern_collection_card ${selectedItems.includes(item.id) ? 'selected' : ''}`} key={item.id} style={{ position: 'relative' }}>
                                    {/* Checkbox */}
                                    <Checkbox
                                        sx={{ position: 'absolute', top: 8, left: 8, zIndex: 10 }}
                                        checked={selectedItems.includes(item.id)}
                                        onChange={() => toggleSelectItem(item.id)}
                                    />

                                    {/* Accent */}
                                    <div className={`accent_bar ${item.status.toLowerCase()}`} />

                                    {/* Content */}
                                    <div className="card_content">
                                        <div className="card_top">
                                            <div className="icon_wrap" style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                <FolderOutlinedIcon />
                                                <span className={`badge1 ${item.type.toLowerCase()}`} style={{ fontSize: '10px', padding: '2px 4px' }}>{item.type}</span>
                                            </div>

                                            <div className="text_wrap">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <h3>{item.name}</h3>
                                                    <span className={`badge1 ${item.status.toLowerCase()}`}>{item.status}</span>
                                                </div>
                                                <p>{item.description}</p>
                                            </div>

                                            {item.featured && (
                                                <StarRoundedIcon className="featured_badge" />
                                            )}
                                        </div>

                                        <div className="card_mid" style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0', marginBottom: '12px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#666', fontSize: '12px', marginBottom: '8px' }}>
                                                <CalendarTodayOutlinedIcon sx={{ fontSize: 16 }} />
                                                <span>{item.metadata.startDate} - {item.metadata.endDate} ({item.metadata.timezone})</span>
                                            </div>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                {item.surfaces.map((s, idx) => (
                                                    <Box key={idx} sx={{ color: '#c49133', display: 'flex', alignItems: 'center' }} title={s}>
                                                        {s === 'Homepage' && <HomeOutlinedIcon sx={{ fontSize: 18 }} />}
                                                        {s === 'Category page' && <CategoryOutlinedIcon sx={{ fontSize: 18 }} />}
                                                        {s === 'Search boost' && <SearchOutlinedIcon sx={{ fontSize: 18 }} />}
                                                        {s === 'App only' || s === 'App' ? <PhoneAndroidOutlinedIcon sx={{ fontSize: 18 }} /> : null}
                                                        {s === 'Web only' ? <WebOutlinedIcon sx={{ fontSize: 18 }} /> : null}
                                                    </Box>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="performance_metrics" style={{ background: '#f9fafb', borderRadius: '6px', padding: '8px', display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                                            <div style={{ textAlign: 'center' }}>
                                                <small style={{ color: '#6b7280', fontSize: '10px', display: 'block' }}>Views</small>
                                                <span style={{ fontWeight: 600, fontSize: '12px' }}>{item.performance.views}</span>
                                            </div>
                                            <div style={{ textAlign: 'center' }}>
                                                <small style={{ color: '#6b7280', fontSize: '10px', display: 'block' }}>Revenue</small>
                                                <span style={{ fontWeight: 600, fontSize: '12px' }}>{item.performance.revenue}</span>
                                            </div>
                                            <div style={{ textAlign: 'center' }}>
                                                <small style={{ color: '#6b7280', fontSize: '10px', display: 'block' }}>CTR</small>
                                                <span style={{ fontWeight: 600, fontSize: '12px' }}>{item.performance.ctr}</span>
                                            </div>
                                        </div>

                                        <div className="card_bottom">
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span className="product_count" style={{ fontWeight: 600 }}>
                                                    {item.products} Products
                                                </span>
                                                <small style={{ color: '#6b7280', fontSize: '11px' }}>{item.reason}</small>
                                            </div>

                                            <div className="actions">
                                                <IconButton onClick={() => navigate(`/manage-collections/view/${item.id}`)}>
                                                    <img src="/static/images/eye_icon.svg" alt="Edit" />
                                                </IconButton>

                                                <IconButton onClick={() => setOpenModal(true)}>
                                                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                </IconButton>
                                                <IconButton>
                                                    <img src="/static/images/trash2_icon.svg" alt="Edit" />

                                                </IconButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <AddCollection
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default ManageCollections;
